export default {
  // Tab names
  'tab.main': 'Main',
  'tab.producers': 'Producers',
  'tab.achievements': 'Achievements',
  'tab.prestige': 'Prestige',
  'tab.settings': 'Settings',

  // Header
  'header.bps': '/sec',
  'header.stage': 'Stage',
  'header.tap': 'TAP!',

  // Combo
  'combo.nice': 'Nice!',
  'combo.great': 'Great!',
  'combo.amazing': 'Amazing!',
  'combo.incredible': 'INCREDIBLE!',
  'combo.legendary': 'LEGENDARY!',
  'combo.label': 'Combo',

  // Critical
  'crit.label': 'CRITICAL!',

  // Producers
  'producer.P1': 'Seed',
  'producer.P2': 'Sprout',
  'producer.P3': 'Seedling',
  'producer.P4': 'Coffee Tree',
  'producer.P5': 'Small Farm',
  'producer.P6': 'Large Farm',
  'producer.P7': 'Roastery',
  'producer.P8': 'Coffee Factory',
  'producer.P9': 'Export Hub',
  'producer.P10': 'Franchise',
  'producer.P11': 'Coffee Empire',
  'producer.P12': 'Coffee Planet',

  // Tap upgrades
  'upgrade.T1': 'Quick Fingers',
  'upgrade.T2': 'Gloves',
  'upgrade.T3': 'Tools',
  'upgrade.T4': 'Machinery',
  'upgrade.T5': 'Robot',
  'upgrade.T6': 'Nano Tech',
  'upgrade.T7': 'Quantum Harvest',
  'upgrade.T8': 'Time Warp',

  // Prestige upgrades
  'prestige.G1': 'Golden Seed',
  'prestige.G1.desc': 'BPS +1 base',
  'prestige.G2': 'Fertile Soil',
  'prestige.G2.desc': 'Tap power x1.5',
  'prestige.G3': 'Beginner Discount',
  'prestige.G3.desc': 'P1~P3 cost -50%',
  'prestige.G4': 'Overnight Growth',
  'prestige.G4.desc': 'Offline efficiency +20%',
  'prestige.G5': 'Speed Growing',
  'prestige.G5.desc': 'Total BPS x2',
  'prestige.G6': 'Lucky Hands',
  'prestige.G6.desc': 'Critical chance +3%',
  'prestige.G7': 'Master Barista',
  'prestige.G7.desc': 'Tap power x3',
  'prestige.G8': 'Wholesale Discount',
  'prestige.G8.desc': 'All costs -20%',
  'prestige.G9': 'Quick Start',
  'prestige.G9.desc': 'Start with 10 P1~P3',
  'prestige.G10': 'Premium Blend',
  'prestige.G10.desc': 'Total BPS x3',
  'prestige.G11': 'Bean of Time',
  'prestige.G11.desc': 'Offline efficiency 100%',
  'prestige.G12': 'Coffee King\'s Crown',
  'prestige.G12.desc': 'Total production x2',
  'prestige.G13': 'Golden Bean Tree',
  'prestige.G13.desc': 'Golden bean gain +20%',
  'prestige.G14': 'Time Travel',
  'prestige.G14.desc': 'Start at stage 5',
  'prestige.G15': 'Infinite Beans',
  'prestige.G15.desc': 'Total production x10',
  'prestige.G16': 'Coffee Big Bang',
  'prestige.G16.desc': 'Golden bean gain x2',

  // Star upgrades
  'star.S1': 'Starting Fund',
  'star.S1.desc': '1M beans at start',
  'star.S2': 'Eternal Gold',
  'star.S2.desc': 'Golden bean gain x2 permanent',
  'star.S3': 'Blessing of Stars',
  'star.S3.desc': 'Total BPS x5 permanent',
  'star.S4': 'Auto Tap',
  'star.S4.desc': '1 auto tap per second',
  'star.S5': 'Combo Master',
  'star.S5.desc': 'Combo duration 3 sec',
  'star.S6': 'Deadly Strike',
  'star.S6.desc': 'Critical multiplier x2',
  'star.S7': 'Cosmic Power',
  'star.S7.desc': 'Total production x10 permanent',
  'star.S8': 'Transcendent Star',
  'star.S8.desc': 'Ascension bonus x3',

  // Varieties
  'variety.V1': 'Arabica',
  'variety.V2': 'Robusta',
  'variety.V3': 'Liberica',
  'variety.V4': 'Excelsa',
  'variety.V5': 'Geisha',
  'variety.V6': 'Kopi Luwak',
  'variety.V7': 'Blue Mountain',
  'variety.V8': 'Kona',
  'variety.V9': 'Yirgacheffe',
  'variety.V10': 'Peaberry',
  'variety.V11': 'Maragogipe',
  'variety.V12': 'St. Helena',

  // Stages
  'stage.1': 'Grandma\'s Garden',
  'stage.2': 'Small Yard',
  'stage.3': 'Coffee Farm',
  'stage.4': 'Roastery',
  'stage.5': 'Coffee Factory',
  'stage.6': 'Global Chain',
  'stage.7': 'Coffee Kingdom',

  // Roasting
  'roast.perfect': 'Perfect Roast!',
  'roast.dark': 'Dark Roast',
  'roast.medium': 'Medium Roast',
  'roast.light': 'Light Roast',
  'roast.burnt': 'Burnt...',
  'roast.raw': 'Undercooked',
  'roast.tap': 'Tap to stop!',
  'roast.reward': 'Reward',
  'roast.double': 'Watch ad for 2x!',
  'roast.collect': 'Collect',

  // Achievements
  'ach.tap1': 'First Steps', 'ach.tap1.desc': 'Tap 100 times',
  'ach.tap2': 'Busy Hands', 'ach.tap2.desc': 'Tap 1,000 times',
  'ach.tap3': 'Tap Master', 'ach.tap3.desc': 'Tap 10,000 times',
  'ach.tap4': 'Legendary Finger', 'ach.tap4.desc': 'Tap 100,000 times',
  'ach.tap5': 'God of Tap', 'ach.tap5.desc': 'Tap 1,000,000 times',
  'ach.tap6': 'Quick Hands', 'ach.tap6.desc': '5 taps per second',
  'ach.tap7': 'Lightning Hands', 'ach.tap7.desc': '10 taps per second',
  'ach.tap8': 'Godly Hands', 'ach.tap8.desc': '15 taps per second',
  'ach.tap9': 'Combo Maniac', 'ach.tap9.desc': 'Reach 20 combo',
  'ach.tap10': 'Legendary Combo', 'ach.tap10.desc': 'Reach 50 combo',

  'ach.prod1': 'First Harvest', 'ach.prod1.desc': 'Harvest 1K beans total',
  'ach.prod2': 'Small Achievement', 'ach.prod2.desc': 'Harvest 100K beans total',
  'ach.prod3': 'Growing Farm', 'ach.prod3.desc': 'Harvest 10M beans total',
  'ach.prod4': 'Coffee Mogul', 'ach.prod4.desc': 'Harvest 1B beans total',
  'ach.prod5': 'Coffee Emperor', 'ach.prod5.desc': 'Harvest 1T beans total',
  'ach.prod6': 'Automation Begins', 'ach.prod6.desc': 'Reach 100 BPS',
  'ach.prod7': 'Factory Running', 'ach.prod7.desc': 'Reach 10K BPS',
  'ach.prod8': 'Industrial Revolution', 'ach.prod8.desc': 'Reach 1M BPS',
  'ach.prod9': 'Global Production', 'ach.prod9.desc': 'Reach 100M BPS',
  'ach.prod10': 'Cosmic Production', 'ach.prod10.desc': 'Reach 10B BPS',

  'ach.bld1': 'Novice Farmer', 'ach.bld1.desc': 'Own 1 each of P1~P4',
  'ach.bld2': 'Intermediate Farmer', 'ach.bld2.desc': 'Own 1 each of P1~P8',
  'ach.bld3': 'Master Farmer', 'ach.bld3.desc': 'Own all producers',
  'ach.bld4': 'Focused Investment', 'ach.bld4.desc': 'Own 10 of one type',
  'ach.bld5': 'Bulk Purchase', 'ach.bld5.desc': 'Own 25 of one type',
  'ach.bld6': 'Collector', 'ach.bld6.desc': 'Own 50 of one type',
  'ach.bld7': 'Monopolist', 'ach.bld7.desc': 'Own 100 of one type',
  'ach.bld8': 'Business Expansion', 'ach.bld8.desc': '100 total producers',
  'ach.bld9': 'Corporate Empire', 'ach.bld9.desc': '500 total producers',
  'ach.bld10': 'World Domination', 'ach.bld10.desc': '1000 total producers',

  'ach.pres1': 'First Rebirth', 'ach.pres1.desc': 'Prestige 1 time',
  'ach.pres2': 'Taste of Repetition', 'ach.pres2.desc': 'Prestige 3 times',
  'ach.pres3': 'Prestige Master', 'ach.pres3.desc': 'Prestige 5 times',
  'ach.pres4': 'Endless Cycle', 'ach.pres4.desc': 'Prestige 10 times',
  'ach.pres5': 'Eternal Ring', 'ach.pres5.desc': 'Prestige 20 times',
  'ach.pres6': 'Reincarnation Expert', 'ach.pres6.desc': 'Prestige 50 times',
  'ach.pres7': 'Golden Harvest', 'ach.pres7.desc': '10 golden beans at once',
  'ach.pres8': 'Golden Storm', 'ach.pres8.desc': '100 golden beans at once',
  'ach.pres9': 'Speed Runner', 'ach.pres9.desc': 'Prestige within 30 min',
  'ach.pres10': 'Lightning Rebirth', 'ach.pres10.desc': 'Prestige within 15 min',

  'ach.spec1': 'Cherry Hunter', 'ach.spec1.desc': 'Tap golden cherry 1 time',
  'ach.spec2': 'Cherry Maniac', 'ach.spec2.desc': 'Tap golden cherry 10 times',
  'ach.spec3': 'Cherry Master', 'ach.spec3.desc': 'Tap golden cherry 50 times',
  'ach.spec4': 'Roasting Beginner', 'ach.spec4.desc': 'Perfect roast 1 time',
  'ach.spec5': 'Roasting Expert', 'ach.spec5.desc': 'Perfect roast 10 times',
  'ach.spec6': 'Variety Collector', 'ach.spec6.desc': 'Collect 5 varieties',
  'ach.spec7': 'Coffee Doctor', 'ach.spec7.desc': 'Collect all 12 varieties',
  'ach.spec8': 'Steady Farmer', 'ach.spec8.desc': '1 hour total playtime',
  'ach.spec9': 'Coffee Addict', 'ach.spec9.desc': '24 hours total playtime',
  'ach.spec10': '7 Day Streak', 'ach.spec10.desc': '7 consecutive days login',

  'ach.mile1': 'Coffee Farmer', 'ach.mile1.desc': 'Reach stage 3',
  'ach.mile2': 'Coffee Entrepreneur', 'ach.mile2.desc': 'Reach stage 5',
  'ach.mile3': 'Coffee King', 'ach.mile3.desc': 'Reach stage 7',
  'ach.mile4': 'Transcender', 'ach.mile4.desc': 'First star ascension',
  'ach.mile5': 'Perfectionist', 'ach.mile5.desc': 'Unlock 50 achievements',

  // Achievement categories
  'ach.cat.tapping': 'Tapping',
  'ach.cat.production': 'Production',
  'ach.cat.producers': 'Producers',
  'ach.cat.prestige': 'Prestige',
  'ach.cat.special': 'Special',
  'ach.cat.milestone': 'Milestone',

  // Prestige panel
  'prestige.title': 'Roast Rebirth',
  'prestige.desc': 'Rebirth to earn golden beans and start stronger!',
  'prestige.goldenBeans': 'Golden Beans',
  'prestige.expected': 'Expected Gain',
  'prestige.rebirth': 'Rebirth',
  'prestige.upgrades': 'Prestige Upgrades',
  'prestige.locked': 'Unlocks at stage 7',
  'prestige.adBonus': 'Watch ad for +30%',

  // Ascension panel
  'ascend.title': 'Star Ascension',
  'ascend.desc': 'Ascend to gain stardust and transcend everything!',
  'ascend.starDust': 'Stardust',
  'ascend.expected': 'Expected Gain',
  'ascend.ascend': 'Ascend',
  'ascend.upgrades': 'Star Upgrades',
  'ascend.locked': 'Requires 10 rebirths + 100 golden beans',

  // Settings
  'settings.bgm': 'Background Music',
  'settings.sfx': 'Sound Effects',
  'settings.vibration': 'Vibration',
  'settings.language': 'Language',
  'settings.reset': 'Reset Data',
  'settings.resetConfirm': 'Are you sure you want to delete all data?',
  'settings.credits': 'Credits',
  'settings.version': 'Version',

  // Boost buttons
  'boost.tap': 'Tap Boost',
  'boost.bps': 'Production Boost',

  // Offline
  'offline.title': 'Welcome back!',
  'offline.earned': 'Offline Earnings',
  'offline.time': 'Time Away',
  'offline.collect': 'Collect',
  'offline.adX3': 'Watch ad for x3',

  // General
  'buy': 'Buy',
  'max': 'Max',
  'level': 'Lv.',
  'locked': 'Locked',
  'owned': 'Owned',
  'on': 'ON',
  'off': 'OFF',
} as const;
